var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",on:{"click":_vm.resend}},[_c('i',{staticClass:"far fa-envelope"}),_vm._v(" Reenviar Email ")])
}
var staticRenderFns = []

export { render, staticRenderFns }